/**
 * ヘッダー
 * @returns { void }
 */
export const header = () => {
  // ポップアップ表示
  $(".l-header__link.is--home").click(function (e) {
    $(".l-header-pop").fadeIn(200).css("display", "flex");
  });

  $(" .l-header-pop__close ").click(function (e) {
    $(".l-header-pop").fadeOut(200);
  });

  $( '.l-header-pop' ).click( function( e ) {
    if ( !$( e.target ).closest( '.l-header-pop__box' ).length ) {
      $( '.l-header-pop' ).fadeOut( 200 );
    }
  } );

  // ハンバーガーメニュー
  $(".l-header__burger").click(function (e) {
    $(this).toggleClass("is--open");

    if ( $(this).hasClass( 'is--open' ) ) {
      $('.l-header__nav').stop().slideDown(200);
    } else {
      $('.l-header__nav').stop().slideUp(200);
    }
  });

  $( '.l-header__nav' ).click( function( e ) {
    if ( !$( e.target ).closest( '.l-header__nav-list' ).length ) {
      $(".l-header__burger").removeClass("is--open");
      $('.l-header__nav').stop().slideUp(200);
    }
  } );
};
